import React from 'react'

type SiteSpecificProviderProps = {
  children: React.ReactNode
}

/**
 * SiteSpecificProvider - A global provider component that enables site-specific context injection
 *
 * This component serves as a placeholder in the breaktime-theme that can be shadowed by individual sites
 * using Gatsby's theme shadowing mechanism. It allows each site to inject their own global providers
 * (such as context providers, theme providers, or other wrapper components) without affecting other sites
 * that use the same theme.
 *
 * @example
 * // In a site-specific implementation (e.g., fifaunilever-site/src/breaktime-theme/.../siteSpecificProvider.tsx):
 * ```tsx
 * import React from 'react'
 * import { SomeContextProvider } from './SomeContext'
 *
 * const SiteSpecificProvider = ({ children }) => {
 *   return (
 *     <SomeContextProvider>
 *       {children}
 *     </SomeContextProvider>
 *   )
 * }
 *
 * export { SiteSpecificProvider }
 * ```
 *
 * @param children - React children to be wrapped by the site-specific provider
 * @returns The children wrapped in the site-specific provider context
 */
const SiteSpecificProvider = ({ children }: SiteSpecificProviderProps) => {
  return <>{children}</>
}

export { SiteSpecificProvider }
